import application from 'application/application';

application.directive('cpfCnpjMask', function() {
	// Função para validar CPF
	function validarCPF(cpf) {
		cpf = cpf.replace(/\D/g, ''); // Remove caracteres não numéricos

		if (cpf.length !== 11) return false;

		// Valida os números repetidos (como 111.111.111-11)
		if (/^(\d)\1{10}$/.test(cpf)) return false;

		// Validação dos 2 últimos dígitos
		let soma = 0;
		let resto;

		for (let i = 1; i <= 9; i++) soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
		resto = (soma * 10) % 11;
		if (resto === 10 || resto === 11) resto = 0;
		if (resto !== parseInt(cpf.charAt(9))) return false;

		soma = 0;
		for (let i = 1; i <= 10; i++)
			soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
		resto = (soma * 10) % 11;
		if (resto === 10 || resto === 11) resto = 0;
		if (resto !== parseInt(cpf.charAt(10))) return false;

		return true;
	}

	// Função para validar CNPJ
	function validarCNPJ(cnpj) {
		cnpj = cnpj.replace(/\D/g, ''); // Remove caracteres não numéricos

		if (cnpj.length !== 14) return false;

		// Valida os números repetidos (como 11.111.111/1111-11)
		if (/^(\d)\1{13}$/.test(cnpj)) return false;

		// Validação dos 2 últimos dígitos
		let soma = 0;
		let peso = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

		for (let i = 0; i < 12; i++) soma += parseInt(cnpj.charAt(i)) * peso[i + 1];
		let resto = soma % 11;

		if (resto < 2) resto = 0;
		else resto = 11 - resto;
		if (resto !== parseInt(cnpj.charAt(12))) return false;

		soma = 0;
		for (let i = 0; i < 13; i++) soma += parseInt(cnpj.charAt(i)) * peso[i];
		resto = soma % 11;
		if (resto < 2) resto = 0;
		else resto = 11 - resto;
		if (resto !== parseInt(cnpj.charAt(13))) return false;

		return true;
	}

	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			function aplicarMascara(value) {
				if (!value) return value;
				value = value.replace(/\D/g, ''); // Remove tudo que não é número

				if (value.length > 11) {
					// Aplica máscara de CNPJ
					value = value.replace(/^(\d{2})(\d)/, '$1.$2');
					value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
					value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
					value = value.replace(/(\d{4})(\d)/, '$1-$2');
				} else {
					// Aplica máscara de CPF
					value = value.replace(/^(\d{3})(\d)/, '$1.$2');
					value = value.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
					value = value.replace(/\.(\d{3})(\d)/, '.$1-$2');
				}

				return value;
			}

			function validarCPFouCNPJ(value) {
				let cleanValue = value.replace(/\D/g, ''); // Remove a formatação para validar corretamente

				return cleanValue.length > 11
					? validarCNPJ(cleanValue)
					: validarCPF(cleanValue);
			}

			ngModel.$parsers.push(function(value) {
				let formattedValue = aplicarMascara(value);

				ngModel.$setViewValue(formattedValue);
				ngModel.$render();
				ngModel.$setValidity('cpfCnpjValid', validarCPFouCNPJ(formattedValue));

				return formattedValue;
			});

			ngModel.$formatters.push(function(value) {
				return aplicarMascara(value);
			});

			element.on('input', function() {
				let value = element.val();
				let formattedValue = aplicarMascara(value);

				element.val(formattedValue);
				ngModel.$setViewValue(formattedValue);
				ngModel.$render();
				ngModel.$setValidity('cpfCnpjValid', validarCPFouCNPJ(formattedValue));
			});

			element.on('blur', function() {
				let value = element.val();

				element.val(aplicarMascara(value));
			});
		}
	};
});
